<template>
  <TransitionRoot
    as="template"
    :show="open && Boolean(data?.data)"
  >
    <div
      class="fixed inset-0 z-40 top-44 sm:top-48 md:top-52 lg:top-40 overflow-y-auto"
      :aria-labelledby="trans.get('miliboo.header.search.search')"
    >
      <TransitionChild
        as="template"
        enter="transition-opacity ease-linear duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="transition-opacity ease-linear duration-300"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 bg-black bg-opacity-25 transition-opacity top-44 sm:top-48 md:top-52 lg:top-40"
          @click="setOpen(false)"
        />
      </TransitionChild>
      <TransitionChild
        as="template"
        enter="transition-opacity ease-linear duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="transition-opacity ease-linear duration-300"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="relative w-full bg-white min-h-40">
          <div class="container mx-auto px-4 md:px-6 lg:px-8 py-4 lg:pb-10 lg:pt-6">
            <section
              class="grid grid-cols-12 gap-6 lg:gap-4 lg:divide-x divide-gray-900 bg-white"
              aria-labelledby="suggestions"
            >
              <aside
                class="col-span-12 lg:col-span-3 space-y-4 lg:space-y-8"
                :aria-label="trans.get('miliboo.filters.categories')"
              >
                <SuggestCategoryList
                  :menu="menu"
                  :products="data.data.products || []"
                />
              </aside>
              <div
                class="col-span-12 lg:col-span-9 space-y-6 lg:space-y-8 lg:pl-12"
                :aria-label="trans.get('miliboo.header.search.products')"
              >
                <SuggestProductList
                  :products="data.data.products || []"
                  :count="data.data.count || 0"
                  :term="term"
                />
              </div>
            </section>
          </div>
        </div>
      </TransitionChild>
    </div>
  </TransitionRoot>
  <slot
    :on-input="({ target: { value } }) => suggest(value)"
    :is-fetching="isFetching"
    :term="term"
  />
</template>
<script setup>
import { inject } from 'vue';
import { TransitionChild, TransitionRoot } from '@headlessui/vue';
import SuggestCategoryList from './SuggestCategoryList.vue';
import SuggestProductList from './SuggestProductList.vue';
import useSuggest from '../composables/useSuggest';

defineProps({
  menu: {
    type: Object,
    required: true,
  },
});

const trans = inject('translate');

const {
  data, isFetching, suggest, open, setOpen, term,
} = useSuggest();

</script>
